import styled from 'styled-components';

const Mask = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: -100vw;
  z-index: -1;
  top: 0;
`;
export default Mask;
